module.exports = __webpack_public_path__ + "img/mnca_logo.d3a4b430.jpg";